import Vue from 'vue';

function ipFormat(value) {
    if (value) {
        return value.replace(/_#@/ig,'.');
    }
}

Vue.prototype.$ipFormat = ipFormat;
Vue.filter('ipFormat', ipFormat);

export default ipFormat;
